import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import ModalAbm from '../../compartidos/abms/ModalAbm';
import { FormIngresoPisoRecepcion } from './FormIngresoPisoRecepcion';
import { Button, Card, Grid } from '@material-ui/core';
import TableGeneric from '../../compartidos/abms/TableGeneric';
import AccionesGenericoAbm from '../../compartidos/abms/AccionesGenericoAbm';
import { useTotem } from '../../../hooks/useCases/useTotem';




export const TotemTurnosRecepciones = () => {

  const dispatch = useDispatch();
  const totem = useTotem();
  const [open, setOpen] = useState(false);
  const [pisoRecepcion, setPisoRecepcion] = useState(false);
  const [openAlta, setOpenAlta] = useState(false);


  useEffect(() => {
    totem.get.recepcionesPisos();
  }, [dispatch]);

  const handleTiposSelectSelect = (item) => {
    setPisoRecepcion(item)
    setOpen(true)
  }

  const cerrarModalAlta = () => setOpenAlta(false)

  const cerrarModalModif = () => setOpen(false)

  const handleSave = (item) => {
    if (pisoRecepcion) {
        totem.update.recepcionesPisos(item);  
    } else {
        totem.insert.recepcionesPisos(item);  

    }
    totem.get.recepcionesPisos(); 
  }

  return (
    <div>
      <Grid container justify="center">
        <ModalAbm title="Agregar Piso y Recepcion " open={openAlta} setOpen={setOpenAlta}>
          <FormIngresoPisoRecepcion pisoRecepcion={null} handleSave={handleSave}  cerrarModal={cerrarModalAlta}/>
        </ModalAbm>
        <ModalAbm title="Modificar Recepcion" open={open} setOpen={setOpen}>
          <FormIngresoPisoRecepcion pisoRecepcion={pisoRecepcion} handleSave={handleSave} cerrarModal={cerrarModalModif} />
        </ModalAbm>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={() => setOpenAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar Piso y Recepcion</Button>
        </Grid>
        {/* <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar recepción" handleSearch={handleSearch} />
        </Grid> */}
        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
        <Card>
        <TableGeneric
              data={totem.data.recepcionPisos}
              sizeTableCells={["8", "25%", "75%"]}
              columns={[
                {
                  label:"",
                  customBody:(item) => (
                    <AccionesGenericoAbm
                      item={item}
                      handleItemSelect={handleTiposSelectSelect}
                      //permisoDelete={CONFIGURACION_CONTRATOS.BAJA}
                      //handleDelete={handleDelete}
                    />
                  )
                },
                {
                  label: "Recepcion",
                  id: "descripcionRecepcion",
                  sort: true

                },
                {
                  label: "Piso",
                  id: "piso",
                  sort: true
                },
              ]}
            />
        </Card>
        </Grid>
      </Grid>
    </div>
  )
}
